import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import { Button } from '~/components/ui/button'

/**
 * Unknown route, unknown tenant, record outside the user's scope, or a staff
 * page for a non-staff user. `homeHref` (an absolute URL, e.g. the apex)
 * replaces "Back to locations" where `/locations` would land here again.
 */
export function NotFoundPage({ homeHref }: { homeHref?: string }) {
  const { t } = useTranslation()
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 text-center">
      <h1 className="text-2xl font-bold">{t('shell.notFound.title')}</h1>
      <p className="text-muted-foreground text-sm">
        {t('shell.notFound.description')}
      </p>
      <Button asChild>
        {homeHref === undefined ? (
          <Link to="/locations">{t('shell.notFound.backToLocations')}</Link>
        ) : (
          <a href={homeHref}>{t('shell.notFound.backToStart')}</a>
        )}
      </Button>
    </div>
  )
}
